import { gql } from "graphql-tag";

// Basic Info
export const SERVICE_BASIC_INFO = gql`
  fragment ServiceBasicInfo on Service {
    name
    documentId
    slug
  }
`;

// About Section
export const ABOUT_INFO = gql`
  fragment AboutInfo on Service {
    about {
      name
      title
      description
    }
  }
`;

// Industries
export const INDUSTRIES_INFO = gql`
  fragment IndustriesInfo on Service {
    industries {
      name
      slug
    }
  }
`;

// Offers and Key Offers
export const OFFERS_INFO = gql`
  fragment OffersInfo on Service {
    offers {
      name
      description
    }
    key_offers {
      name
      description
    }
  }
`;

// Technologies
export const TECHNOLOGIES_INFO = gql`
  fragment TechnologiesInfo on Service {
    technologies {
      name
      slug
    }
  }
`;

// Our Expertises
export const OUR_EXPERTISES_INFO = gql`
  fragment OurExpertisesInfo on Service {
    our_expertises {
      logo {
        url
        alternativeText
      }
      name
    }
  }
`;

// Client Technologies
export const CLIENT_TECHNOLOGIES_INFO = gql`
  fragment ClientTechnologiesInfo on Service {
    client_technologies {
      name
      logo {
        url
        alternativeText
        formats
      }
    }
  }
`;

// Credentials Stats
export const CREDENTIALS_STATS_INFO = gql`
  fragment CredentialsStatsInfo on Service {
    credentials_stats {
      name
      content
    }
  }
`;

// What Do We Offer
export const WHAT_DO_WE_OFFER_INFO = gql`
  fragment WhatDoWeOfferInfo on Service {
    what_do_we_offers {
      name
      description
      key_what_do_offers {
        name
        description
      }
    }
  }
`;

// Schedule Demo
export const SCHEDULE_DEMO_INFO = gql`
  fragment ScheduleDemoInfo on Service {
    schedule_demo {
      name
      title
      description
    }
  }
`;

// Service Benefits
export const SERVICE_BENEFITS_INFO = gql`
  fragment ServiceBenefitsInfo on Service {
    service_benefits {
      name
      title
      slug
    }
  }
`;

// Meta Tags
export const META_TAG_INFO = gql`
  fragment MetaTagInfo on Service {
    meta_tag {
      title
      description
      keywords
      slug
    }
  }
`;

// Agile Method
export const AGILE_METHOD_INFO = gql`
  fragment AgileMethodInfo on Service {
    agile_method {
      name
      title
      description
    }
  }
`;
